module.exports = __webpack_public_path__ + "media/images/browser_payment_finished-2557b73e1fac7d8dd7ba6caee528f7f0.png";